import script from "./CarrierCardView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarrierCardView.vue?vue&type=script&lang=ts&setup=true"

import "./CarrierCardView.vue?vue&type=style&index=0&id=0e74ab66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e74ab66"]])

export default __exports__